module.exports = __webpack_public_path__ + "img/arrow_down_b.d51c4cbd.svg";